import { createContext } from 'react';

export const AccessContext = createContext({
  loading: true,
  bypass: false,
  businessCases: [],
  personas: [],
  activePersona: null,
  services: [],
  diagnostics: null,
  setActivePersona: async () => {},
  refreshAccess: async () => {},
  can: () => false,
});
